
/* injects from baggage-loader */
require('./style.scss');

import React, { useEffect, useRef, useState } from 'react';
import { connect } from "react-redux";
import { HandleLotteryGame } from '../../../helpers/casino/helpers';
import Config from '../../../config/main';
import { usePrevious } from '../../hooks/previous';
import { casinoGamesPageOpened, UpperScreen } from '../../../actions/terminal';
import { thirdPartyGamesConfig } from './constants';
import Helpers from '../../../helpers/helperFunctions';
import { broadcast, broadcastChannels } from '../../../helpers/broadcast';
import { useMemo } from 'react';

const ThirdPartyGame = ({ dispatch, user, params: { id }, router }) => {
    const prevId = usePrevious(id);
    const [iframeUrl, setIframeUrl] = useState();

    const withoutBackButtonIds = ["112001", "112002", "112005"]

    const iframeRef = useRef();

    const Handler = useMemo(() => {
        const { Handler } = thirdPartyGamesConfig[id] || {};
        return Handler ? new Handler() : null;
    }, [id]); 

    useEffect(() => {
        window.addEventListener('message', (message) => {
            message.source == iframeRef.current?.contentWindow && Handler?.onIframeMessage(message);
        });
    }, [Handler]);

    useEffect(() => {
        const { limitgroupId, tableId, hasSecondScreen, openType } = thirdPartyGamesConfig[id] || {};

        id !== prevId && Config.ticketBasedGameIds.includes(id) && dispatch(casinoGamesPageOpened());

        setIframeUrl(HandleLotteryGame(user, [id], false, limitgroupId, tableId, openType));

        if (hasSecondScreen) {
            const upperScreenUrl = HandleLotteryGame(user, [id], true, limitgroupId, tableId, openType);
            if (upperScreenUrl) {
                Helpers.isSplitScreenAvailable()
                    ? broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                        detail: { command: 'Video', id: 111, url: upperScreenUrl, providerId: 54 }
                    })) : dispatch(UpperScreen({
                        type: "Video",
                        id: 111, //doesn't matter what id
                        videoURL: upperScreenUrl,
                        tv_type: 21
                    }));
            }
        }
    }, [id, prevId, user]);

    const handleBack = () => {
        const providersList = Object.values(Config.virtualGames.providers)

        if (providersList.length === 1) router.push('/')
        else router.goBack()
    }

    return (
        <div className='third-party-game-container'>
            {!withoutBackButtonIds.includes(id) && <div onClick={handleBack}>Back</div>}
            <iframe key={iframeUrl} src={iframeUrl} ref={iframeRef} />
        </div>
    )
};

const mapStateToProps = store => ({
    user: store.user,
});

export default connect(mapStateToProps)(ThirdPartyGame);